<app-stepper [step]="step"></app-stepper>
<div>
	<div>

		<form #donationForm="ngForm" (ngSubmit)="onSubmit()" class="donation-form" >

			<p class="step1-story" [innerHTML]="'donation.story' | translate"></p>
			<div class="form-group">
				<mat-radio-group name="amount_option" [(ngModel)]="donationOption" required class="radio-group-amount">
					<mat-radio-button *ngFor="let option of controller.donationOptions" [value]="option" class="radio-button-amount" >
						<span *ngIf="option.label !== 'donation.option_other.name'">{{controller.getCurSym()}} </span>
						<span  translate [innerHTML]="option.label"></span>
					</mat-radio-button>
				</mat-radio-group>
			</div>

			<div class="form-group" [hidden]="!controller.showCustomAmount" >
				<mat-form-field >
					<input  matInput
							name="customAmount"
							type="number"
							step="1"
							id="customAmount"
							class="form-control"
							min="5"
							[required]="controller.showCustomAmount"
							pattern="^[0-9]+$"
							[(ngModel)]="controller.customAmount"
							placeholder="{{'donation.option_other.placeholder' | translate}}"
							>
					<span matPrefix>{{controller.getCurSym()}}</span>
					<mat-error translate="donation.option_other.error"></mat-error>
				</mat-form-field>
			</div>

			<div class="form-group">
				<button type="submit" btn btn-secondary btn-block btn-lg [disabled]="!donationForm.form.valid" translate="donation.next_step"></button>
			</div>
		</form>
	</div>

</div>
